const TheContainer = () => import("@/containers/TheContainer.vue");
const PayoutList = () => import("@/domain/payout/PayoutList.vue");
const PayoutDetail = () => import("@/domain/payout/PayoutDetail.vue");

export default [
    {
        path: '/events/:contractId/payouts',
        component: TheContainer,
        meta: {
            perms: ['payout.see']
        },
        redirect: {name: 'payoutList'},
        children: [
            {
                path: '',
                name: 'payoutList',
                component: PayoutList,
                meta: {
                    label: 'Payouts',
                    breadcrumb: (context) => {
                        const contract = context.store.getters['events/contract']
                        const contractName = contract && contract.id == context.route.params.contractId 
                            ? (contract.name || `Contract #${contract.id}`)
                            : `Contract #${context.route.params.contractId}`
                        
                        // Trigger async load if needed (non-blocking)
                        if (!contract || contract.id != context.route.params.contractId) {
                            context.store.dispatch('events/setActiveContract', context.route.params.contractId)
                                .catch(err => console.error('Failed to load contract for breadcrumb:', err))
                        }
                        
                        return [
                            {
                                text: 'Eventi',
                                to: { name: 'eventList' }
                            },
                            {
                                text: contractName,
                                to: {
                                    name: 'eventList',
                                    params: { contractId: context.route.params.contractId }
                                }
                            },
                            {
                                text: 'Payouts'
                                // No 'to' - this is the current page (leaf)
                            }
                        ]
                    }
                },
            },
            {
                path: ':payoutId',
                name: 'payoutDetail',
                component: PayoutDetail,
                meta: {
                    label: 'Payout Detail',
                    breadcrumb: (context) => {
                        const contract = context.store.getters['events/contract']
                        const payout = context.store.getters['payout/payout']
                        
                        const contractName = contract && contract.id == context.route.params.contractId 
                            ? (contract.name || `Contract #${contract.id}`)
                            : `Contract #${context.route.params.contractId}`
                        
                        const payoutName = payout && payout.id == context.route.params.payoutId
                            ? `Payout #${payout.id}`
                            : `Payout #${context.route.params.payoutId}`
                        
                        // Trigger async loads if needed (non-blocking)
                        if (!contract || contract.id != context.route.params.contractId) {
                            context.store.dispatch('events/setActiveContract', context.route.params.contractId)
                                .catch(err => console.error('Failed to load contract for breadcrumb:', err))
                        }
                        if (!payout || payout.id != context.route.params.payoutId) {
                            context.store.dispatch('payout/fetchPayoutDetail', context.route.params.payoutId)
                                .catch(err => console.error('Failed to load payout for breadcrumb:', err))
                        }
                        
                        return [
                            {
                                text: 'Eventi',
                                to: { name: 'eventList' }
                            },
                            {
                                text: contractName,
                                to: {
                                    name: 'eventList',
                                    params: { contractId: context.route.params.contractId }
                                }
                            },
                            {
                                text: 'Payouts',
                                to: {
                                    name: 'payoutList',
                                    params: { contractId: context.route.params.contractId }
                                }
                            },
                            {
                                text: payoutName
                                // No 'to' - this is the current page (leaf)
                            }
                        ]
                    }
                },
            }
        ]
    }
]